<template>
  <div class="mx-auto max-w-lg px-6 py-24">
    <div class="flex flex-col items-center gap-3 rounded-[var(--radius-lg)] border border-dashed border-border bg-card px-6 py-14 text-center">
      <div class="grid h-16 w-16 place-items-center rounded-full bg-secondary text-2xl text-muted-foreground">۴۰۴</div>
      <h3 class="text-lg font-bold">صفحه پیدا نشد</h3>
      <p class="max-w-sm text-sm text-muted-foreground leading-relaxed">نشانی موردنظر وجود ندارد یا جابه‌جا شده است.</p>
      <div class="mt-2">
        <Commerce-Button variant="primary" size="lg" @click="handleError">بازگشت به خانه</Commerce-Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const router = useRouter()

function handleError() {
  router.push('/')
}
</script>
